var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 17.7082H5.83329C2.79163 17.7082 1.04163 15.9582 1.04163 12.9165V7.08317C1.04163 4.0415 2.79163 2.2915 5.83329 2.2915H14.1666C17.2083 2.2915 18.9583 4.0415 18.9583 7.08317V12.9165C18.9583 15.9582 17.2083 17.7082 14.1666 17.7082ZM5.83329 3.5415C3.44996 3.5415 2.29163 4.69984 2.29163 7.08317V12.9165C2.29163 15.2998 3.44996 16.4582 5.83329 16.4582H14.1666C16.55 16.4582 17.7083 15.2998 17.7083 12.9165V7.08317C17.7083 4.69984 16.55 3.5415 14.1666 3.5415H5.83329Z",
    fill: "#79EA8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99986 10.725C9.29986 10.725 8.59153 10.5083 8.04986 10.0666L5.44152 7.98331C5.17485 7.76664 5.12486 7.37497 5.34153 7.10831C5.55819 6.84164 5.94986 6.79164 6.21653 7.00831L8.82485 9.09164C9.45819 9.59998 10.5332 9.59998 11.1665 9.09164L13.7749 7.00831C14.0415 6.79164 14.4415 6.83331 14.6499 7.10831C14.8665 7.37497 14.8249 7.77498 14.5499 7.98331L11.9415 10.0666C11.4082 10.5083 10.6999 10.725 9.99986 10.725Z",
    fill: "#79EA8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2a9ce5ab6f8f33b1a107ba6d70e6b37e.svg";
export { ForwardRef as ReactComponent };